import styles from './button.module.css';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  look?: 'primary' | 'secondary';
  formReady?: boolean;
}

/**
 * Button.
 *
 * @param {ButtonProps} props button's props
 * @returns {React.ReactElement<ButtonProps>} Button.
 */
function Button(props: ButtonProps): React.ReactElement<ButtonProps> {
  const { children, look = 'primary', formReady = true, ...rest } = props;
  return (
    // eslint-disable-next-line react/button-has-type
    <button
      className={`${styles.button} ${styles[`button--${look}`]} ${
        !formReady ? styles['button--disabled'] : ''
      }`}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      {children}
    </button>
  );
}

export default Button;
